import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=01927c70&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=01927c70&lang=scss&scoped=true&"
import style1 from "./Company.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01927c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01927c70')) {
      api.createRecord('01927c70', component.options)
    } else {
      api.reload('01927c70', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=01927c70&scoped=true&", function () {
      api.rerender('01927c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/Company.vue"
export default component.exports